(function() {
  document.querySelectorAll('.\\#product-meta-block').forEach(function(block) {
    if (block.offsetHeight === 0) {
      block.style.display = 'none';
    }
  })

  document.querySelectorAll('.\\#product-meta-block').forEach(function(block) {
    const observer = new MutationObserver(function() {
      observer.disconnect();

      console.log('Mutation detected, running visibility check.');

      block.style.display = '';
      if (block.offsetHeight === 0) {
        block.style.display = 'none';
      } else {
        block.style.display = '';
      }

      observer.observe(block, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    observer.observe(block, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})()
